import React, { Component } from 'react';
import LottieLoader from '@wix/branding-client-lib/dist/src/components/LottieLoader/LottieLoader';
import { withTranslation } from '@wix/wix-i18n-config';
import animationData from '@wix/branding-client-lib/dist/src/assets/animations/WebsiteLoader.json';

class LottieLoaderServiceBng extends Component {
  render() {
    const { t } = this.props;
    const labelText = t('BNG_NAMES_LOADER_TEXT');
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <LottieLoader key="lottie" label={labelText} loop animationData={animationData} />
      </div>
    );
  }
}

export default withTranslation()(LottieLoaderServiceBng);
